import type { CatalogItem } from "@albertine/types/openapi/lmt";
import { Lib } from "albertine-shared-web";
import { Car, Footprints } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Spinner } from "@/components/ui/spinner";
import { useDistances } from "./MapView/useDistances";

export function DistanceBadges({
    item,
    mapCenter,
}: {
    item: CatalogItem;
    mapCenter: { lat: number; lng: number } | undefined;
}) {
    const { driving, walking, isLoading } = useDistances(item, mapCenter ?? null);

    if (!mapCenter || !item.locationGeoPoint) {
        return null;
    }

    return (
        <Lib.Flex.Row gap="value8">
            <Badge variant="secondary" className="gap-2">
                {isLoading ? (
                    <Spinner className="size-3" />
                ) : (
                    <>
                        <Car className="size-3" />
                        {driving ?? "—"}
                    </>
                )}
            </Badge>

            <Badge variant="secondary" className="gap-2">
                {isLoading ? (
                    <Spinner className="size-3" />
                ) : (
                    <>
                        <Footprints className="size-3" />
                        {walking ?? "—"}
                    </>
                )}
            </Badge>
        </Lib.Flex.Row>
    );
}
